import React, { useContext, useState } from 'react';
import { Box, Typography, CircularProgress } from '@material-ui/core';
import {
  MainContainer,
  MainContainerTitle,
  CustomButton,
  CustomSeparator,
} from '../../styles';
import { ContentContainer, ButtonsContainer, ButtonSpacer } from './styles';
import ItemSelection from './components/ItemsSelection';
import ItemReasonsResolutionSelection from './components/ItemReasonsResolutionSelection';
import { GeneralContext } from '../../../../../../core/app-context/GeneralContext';
import usePageStore from '../../../../store/pageStore';
import useConfigsStore from '../../../../store/configsStore';

export default function FetchedOrderItems({ handleFormSubmit }) {
  const { setInfoMessage } = useContext(GeneralContext);

  //!
  const devolutionPageConfigs = useConfigsStore(
    (state) => state.devolutionPageConfigs,
  );

  const [step, setStep] = useState(0);
  const [itemStep, setItemStep] = useState(0);

  const isOrderBeingCreated = usePageStore(
    (state) => state.isOrderBeingCreated,
  );
  const vtexOrderItems = usePageStore((state) => state.vtexOrderItems);
  const validVtexOrderItems = usePageStore(
    (state) => state.validVtexOrderItems,
  );
  const selectedVtexItem = usePageStore((state) => state.selectedVtexItem);
  const setSelectedVtexItem = usePageStore(
    (state) => state.setSelectedVtexItem,
  );
  const setValidVtexOrderItems = usePageStore(
    (state) => state.setValidVtexOrderItems,
  );

  const handleNextButtonPress = () => {
    if (step === 0) {
      const validItems = vtexOrderItems.filter(
        (item) => item.selectedQuantity > 0,
      );
      if (validItems.length > 0) {
        setStep(1);
        setValidVtexOrderItems(validItems);
      } else {
        setInfoMessage(
          'Pelo menos um item deve ser selecionado para prosseguir',
        );
        return;
      }
    } else if (
      selectedVtexItem < validVtexOrderItems.length - 1 ||
      itemStep === 0
    ) {
      if (itemStep === 0) {
        if (!validVtexOrderItems[selectedVtexItem].reason) {
          setInfoMessage('Selecione um motivo para prosseguir');
          return;
        } else {
          setItemStep(1);
        }
      } else {
        if (!validVtexOrderItems[selectedVtexItem].resolution) {
          setInfoMessage('Entre com a resolução desejada para prosseguir');
          return;
        } else {
          setItemStep(0);
          setSelectedVtexItem(selectedVtexItem + 1);
        }
      }
    } else {
      if (!validVtexOrderItems[selectedVtexItem].resolution) {
        setInfoMessage('Entre com a resolução desejada para prosseguir');
        return;
      } else {
        handleFormSubmit();
      }
    }
  };
  const handleBackButtonPress = () => {
    if (itemStep === 1) {
      setItemStep(0);
    } else {
      if (selectedVtexItem === 0) {
        setStep(0);
      } else {
        setItemStep(1);
        setSelectedVtexItem(selectedVtexItem - 1);
      }
    }
  };
  const buttonNextText = () => {
    if (
      step === 0 ||
      selectedVtexItem < validVtexOrderItems.length - 1 ||
      (selectedVtexItem === validVtexOrderItems.length - 1 && itemStep === 0)
    ) {
      return 'Avançar';
    }
    return 'Criar Pedido';
  };

  const primaryColor = devolutionPageConfigs?.primaryColor;
  const secondaryColor = devolutionPageConfigs?.secondaryColor || '#ffffff';
  const fontColor = devolutionPageConfigs?.fontColor || '#000000';
  const fontColorSecondary =
    devolutionPageConfigs?.fontColorSecondary || '#000000';
  const fontFamily =
    devolutionPageConfigs?.fontFamily || 'helvetica, sans-serif';
  return (
    <MainContainer backgroundcolor={secondaryColor}>
      {step === 0 && (
        <MainContainerTitle padding="0px">
          <Typography variant="h5">
            <Box
              sx={{
                fontWeight: 'bold',
                color: fontColor,
                fontFamily,
              }}
            >
              Adicione os itens do pedido
            </Box>
          </Typography>
          <CustomSeparator />
          <Typography style={{ color: fontColor, fontFamily }}>
            Apenas os itens com pelo menos 1 unidade selecionada serão incluídos
            no pedido de devolução.
          </Typography>
        </MainContainerTitle>
      )}
      <ContentContainer>
        {step === 0 && <ItemSelection />}
        {step === 1 && (
          <ItemReasonsResolutionSelection
            itemStep={itemStep}
            item={validVtexOrderItems[selectedVtexItem]}
          />
        )}
      </ContentContainer>
      <ButtonsContainer>
        {step === 1 && (
          <>
            <CustomButton
              styleType="outlined"
              color={primaryColor}
              secondaryColor={secondaryColor}
              onClick={handleBackButtonPress}
            >
              <Typography style={{ color: fontColor, fontFamily }}>
                Voltar
              </Typography>
            </CustomButton>
            <ButtonSpacer />
          </>
        )}
        <CustomButton
          color={primaryColor}
          secondaryColor={secondaryColor}
          onClick={handleNextButtonPress}
        >
          {isOrderBeingCreated ? (
            <CircularProgress style={{ color: fontColorSecondary }} />
          ) : (
            <Typography style={{ color: fontColorSecondary, fontFamily }}>
              {buttonNextText()}
            </Typography>
          )}
        </CustomButton>
      </ButtonsContainer>
    </MainContainer>
  );
}
